import { ProductPreviewActionTypes } from '../../../enums/ActionEnums';
export const productPreviewActions = {
    disableImageTouchZoomHint: () => ({
        type: ProductPreviewActionTypes.DISABLE_IMAGE_TOUCH_ZOOM_HINT,
    }),
    updateImageTouchZoomHint: (payload) => ({
        type: ProductPreviewActionTypes.UPDATE_IMAGE_TOUCH_ZOOM_HINT,
        payload,
    }),
};
